export default __webpack_public_path__ + "static/media/logo_bpa.3f6ebbb6.png";